import { useState } from "react";
import {
  sendPasswordResetEmail,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { AZUL, CINZA_ESC, TEXTO, FONTE, FUNDO_SUAVE } from "../tema";
import { Card, Btn, Input, StatusBox } from "../componentes";
import { VERSAO } from "../versao";

// ── Telas de autenticação ─────────────────────────────────────
export function TelaCarregando() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: FUNDO_SUAVE, fontFamily: FONTE }}>
      <div style={{ color: CINZA_ESC, fontSize: 15 }}>Carregando…</div>
    </div>
  );
}

export function TelaLogin({ onEntrar, erro, carregando }) {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [modoReset, setModoReset] = useState(false);
  const [emailReset, setEmailReset] = useState("");
  const [statusReset, setStatusReset] = useState(null);
  const [enviandoReset, setEnviandoReset] = useState(false);

  function submeter() {
    if (!email || !senha) return;
    onEntrar(email, senha);
  }

  function aoTeclar(e) {
    if (e.key === "Enter") submeter();
  }

  async function enviarReset() {
    if (!emailReset.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setStatusReset({ tipo: "erro", msg: "Digite um e-mail válido." });
      return;
    }
    setEnviandoReset(true);
    setStatusReset(null);
    try {
      await sendPasswordResetEmail(auth, emailReset.trim());
      // Mensagem neutra: não revela se o e-mail existe ou não (boa prática).
      setStatusReset({ tipo: "ok", msg: "Se este e-mail estiver cadastrado, um link de redefinição foi enviado. Verifique sua caixa de entrada e o spam." });
    } catch (e) {
      const code = e.code || "";
      if (code.includes("invalid-email")) {
        setStatusReset({ tipo: "erro", msg: "E-mail inválido." });
      } else {
        // Mesmo em erro de "usuário não encontrado", mostramos mensagem neutra.
        setStatusReset({ tipo: "ok", msg: "Se este e-mail estiver cadastrado, um link de redefinição foi enviado. Verifique sua caixa de entrada e o spam." });
      }
    } finally {
      setEnviandoReset(false);
    }
  }

  if (modoReset) {
    return (
      <div style={{ minHeight: "100vh", background: FUNDO_SUAVE, display: "flex", alignItems: "center", justifyContent: "center", padding: 16, fontFamily: FONTE }}>
        <div style={{ width: "100%", maxWidth: 400 }}>
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <img src="/logo-revelar-horizontal.png" alt="Revelar Talentos" style={{ height: 50, marginBottom: 12, objectFit: "contain" }} />
            <div style={{ fontWeight: 800, fontSize: 19, color: TEXTO }}>Recuperar acesso</div>
            <div style={{ fontSize: 13, color: CINZA_ESC, marginTop: 3 }}>Enviaremos um link de redefinição para o seu e-mail</div>
          </div>
          <Card style={{ boxShadow: "0 10px 30px rgba(22, 52, 111, 0.10)" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <Input label="E-mail institucional" value={emailReset} onChange={setEmailReset} type="email" placeholder="seu.email@instituicao.br"
                onKeyDown={e => { if (e.key === "Enter") enviarReset(); }} />
              {statusReset && <StatusBox tipo={statusReset.tipo} msg={statusReset.msg} />}
              <Btn onClick={enviarReset} disabled={enviandoReset} style={{ marginTop: 4 }}>
                {enviandoReset ? "Enviando…" : "Enviar link de redefinição"}
              </Btn>
              <Btn onClick={() => { setModoReset(false); setStatusReset(null); }} variant="secondary">
                Voltar ao login
              </Btn>
            </div>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: FUNDO_SUAVE, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 16, fontFamily: FONTE }}>
      <div style={{ width: "100%", maxWidth: 400 }}>
        <div style={{ textAlign: "center", marginBottom: 22 }}>
          <img src="/logo-revelar-horizontal.png" alt="Revelar Talentos" style={{ height: 60, marginBottom: 14, objectFit: "contain" }} />
          <div style={{ fontWeight: 800, fontSize: 19, color: TEXTO, letterSpacing: -0.3 }}>Portal Revelar Talentos</div>
          <div style={{ fontSize: 13, color: CINZA_ESC, marginTop: 3 }}>Frequência • Acompanhamento • Gestão</div>
        </div>
        <Card style={{ boxShadow: "0 10px 30px rgba(22, 52, 111, 0.10)" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Input label="E-mail institucional" value={email} onChange={setEmail} type="email" placeholder="seu.email@instituicao.br" onKeyDown={aoTeclar} />
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: CINZA_ESC, display: "block", marginBottom: 5 }}>Senha</label>
              <div style={{ position: "relative" }}>
                <input
                  type={mostrarSenha ? "text" : "password"}
                  value={senha}
                  onChange={e => setSenha(e.target.value)}
                  onKeyDown={aoTeclar}
                  placeholder="••••••••"
                  style={{ width: "100%", border: "1px solid #D1D5DB", borderRadius: 10, padding: "10px 44px 10px 12px", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box" }}
                />
                <button
                  type="button"
                  onClick={() => setMostrarSenha(v => !v)}
                  aria-label={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                  title={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                  style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: 6, lineHeight: 0, color: CINZA_ESC, display: "flex" }}
                >
                  {mostrarSenha ? (
                    // olho cortado (senha visível — clique para ocultar)
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </svg>
                  ) : (
                    // olho aberto (senha oculta — clique para mostrar)
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
            {erro && <StatusBox tipo="erro" msg={erro} />}
            <Btn onClick={submeter} disabled={carregando} style={{ marginTop: 4 }}>
              {carregando ? "Entrando…" : "Acessar portal"}
            </Btn>
            <button onClick={() => { setModoReset(true); setEmailReset(email); setStatusReset(null); }}
              style={{ background: "none", border: "none", cursor: "pointer", color: AZUL, fontSize: 13, fontWeight: 600, marginTop: 2 }}>
              Recuperar acesso
            </button>
          </div>
        </Card>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, marginTop: 16, fontSize: 12, color: CINZA_ESC }}>
          <span style={{ fontSize: 13 }}>🔒</span>
          <span style={{ fontWeight: 600 }}>Acesso protegido</span>
          <span style={{ color: "#CBD5E1" }}>·</span>
          <span>Versão {VERSAO}</span>
        </div>
      </div>
    </div>
  );
}

// ── Modal: Alterar senha (usuário logado) ─────────────────────
export function ModalAlterarSenha({ onFechar, onSucesso }) {
  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [status, setStatus] = useState(null);
  const [salvando, setSalvando] = useState(false);

  async function alterar() {
    if (!senhaAtual || !novaSenha || !confirmar) {
      setStatus({ tipo: "erro", msg: "Preencha todos os campos." });
      return;
    }
    if (novaSenha.length < 6) {
      setStatus({ tipo: "erro", msg: "A nova senha deve ter ao menos 6 caracteres." });
      return;
    }
    if (novaSenha !== confirmar) {
      setStatus({ tipo: "erro", msg: "A confirmação não corresponde à nova senha." });
      return;
    }
    if (novaSenha === "123456") {
      setStatus({ tipo: "erro", msg: "Escolha uma senha diferente da padrão." });
      return;
    }
    setSalvando(true);
    setStatus(null);
    try {
      const usuario = auth.currentUser;
      // Reautentica com a senha atual antes de trocar (exigência do Firebase).
      const cred = EmailAuthProvider.credential(usuario.email, senhaAtual);
      await reauthenticateWithCredential(usuario, cred);
      await updatePassword(usuario, novaSenha);
      // Marca no doc que a senha padrão foi trocada (esconde a faixa).
      await setDoc(doc(db, "users", usuario.uid), { senhaAlterada: true }, { merge: true });
      onSucesso();
    } catch (e) {
      const code = e.code || "";
      if (code.includes("wrong-password") || code.includes("invalid-credential")) {
        setStatus({ tipo: "erro", msg: "A senha atual está incorreta." });
      } else if (code.includes("too-many-requests")) {
        setStatus({ tipo: "erro", msg: "Muitas tentativas. Aguarde alguns minutos e tente de novo." });
      } else {
        setStatus({ tipo: "erro", msg: "Não foi possível alterar a senha: " + (e.message || "") });
      }
    } finally {
      setSalvando(false);
    }
  }

  return (
    <div style={{ minHeight: "100vh", width: "100%", position: "absolute", top: 0, left: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "48px 16px", zIndex: 50 }}>
      <div style={{ width: "100%", maxWidth: 420 }}>
        <Card>
          <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 4 }}>Alterar senha</div>
          <div style={{ fontSize: 13, color: CINZA_ESC, marginBottom: 16 }}>
            Digite a senha atual e escolha uma nova.
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <Input label="Senha atual" value={senhaAtual} onChange={setSenhaAtual} type="password" placeholder="••••••••" />
            <Input label="Nova senha" value={novaSenha} onChange={setNovaSenha} type="password" placeholder="mínimo 6 caracteres" />
            <Input label="Confirmar nova senha" value={confirmar} onChange={setConfirmar} type="password" placeholder="repita a nova senha"
              onKeyDown={e => { if (e.key === "Enter") alterar(); }} />
            {status && <StatusBox tipo={status.tipo} msg={status.msg} />}
            <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
              <Btn onClick={alterar} disabled={salvando}>{salvando ? "Salvando…" : "Salvar nova senha"}</Btn>
              <Btn onClick={onFechar} variant="secondary" disabled={salvando}>Cancelar</Btn>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}